import React, { useEffect, useState } from "react";

//components
import Title from "../../../common/components/Title";
import Table from "./components/Table";
import Pagination from "../../../common/components/Pagination";
import AttributeForm from "./components/AttributeForm";

const Attributes = ({page}) => {

    const [attributes, setAttributes] = useState([]);
    const [attributesData, setAttributesData] = useState({
        attributes: [
            {
                attribute_name: '',
                attribute_slug: '',
                attribute_type: '',
                options: [],
            },
        ],
    });
    const [field, setField] = useState([{ label: '', color: '', image: null, uploader: false }]);
    const [editingAttribute, setEditingAttribute] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPage, setTotalPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);

    const fetchData = async () => {
        setIsLoading(true);

        try {
            const response = await fetch( `${EASYCOMMERCE.rest_base}/attributes?page=${page}&per_page=${postPerPage}` , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        });

        const jsonData = await response.json();
        setAttributes(jsonData.data.attributes);
        setTotalPage(jsonData.data.pagination.total_pages);

        } catch (error) {
            console.error('Error fetching data:', error);
        }finally {
            setIsLoading(false);
            easycommerce_modal(false);
        }
    }

    const handleEditAttribute = (attributeData) => {
        setEditingAttribute(attributeData);
    };

    const handleAttributeCreated = () => {
        fetchData();
        setEditingAttribute(null);
    };

    const handleAttributeUpdated = () => {
        fetchData();
        setEditingAttribute(null);
    };

    const handleCancel = () => {
        setEditingAttribute(null);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="product-panel-title mb-4">
                <h3>Attributes</h3>
            </div>
            <div className="grid min-[1400px]:grid-cols-10 min-[1280px]:grid-cols-12 gap-6 items-start">
                <div className="bg-white min-[1400px]:col-span-6 min-[1280px]:col-span-12 w-full self-start border border-solid border-ec-table-stock rounded-xl">
                    <div className="flex items-center border-b px-6 py-3.5">
                        <Title title="Attributes List" />
                    </div>

                    <div className="p-6">
                        <Table
                            attributes={attributes}
                            setAttributes={setAttributes}
                            fetchData={fetchData}
                            onEdit={handleEditAttribute}
                            setAttributesData={setAttributesData}
                            setField={setField}
                            setEditingAttribute={setEditingAttribute}
                            isLoading={isLoading}
                        />
                    </div>
                    {totalPage > 1 && (
                        <Pagination
                            baseSlug="attributes"
                            current={page}
                            total={totalPage}
                        />
                    )}
                </div>

                <div className="bg-white min-[1400px]:col-span-4 min-[1280px]:col-span-12 w-full self-start border border-solid border-ec-table-stock rounded-xl">
                    <div className="flex items-center border-b pl-6 py-3.5">
                        <Title title={editingAttribute ? 'Edit Attribute: ' + attributesData.attributes[0].attribute_name : "Add New Attribute"} />
                    </div>
                    <AttributeForm
                        editingAttribute={editingAttribute}
                        attributes={attributes}
                        attributesData={attributesData}
                        setAttributesData={setAttributesData}
                        field={field}
                        setField={setField}
                        onAttributeCreated={handleAttributeCreated}
                        onAttributeUpdated={handleAttributeUpdated}
                        onCancel={handleCancel}
                    />
                </div>
            </div>
        </>
    );
};

export default Attributes;